var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 6.5H8.66667V5.41667H2.16667V6.5ZM2.16667 4.875H8.66667V3.79167H2.16667V4.875ZM2.16667 3.25H8.66667V2.16667H2.16667V3.25ZM10.8333 10.8333L8.66667 8.66667H1.08333C0.785417 8.66667 0.530382 8.56059 0.318229 8.34844C0.106076 8.13628 0 7.88125 0 7.58333V1.08333C0 0.785417 0.106076 0.530382 0.318229 0.318229C0.530382 0.106076 0.785417 0 1.08333 0H9.75C10.0479 0 10.303 0.106076 10.5151 0.318229C10.7273 0.530382 10.8333 0.785417 10.8333 1.08333V10.8333ZM1.08333 7.58333H9.12708L9.75 8.19271V1.08333H1.08333V7.58333Z",
    fill: "#054254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentText);
export default __webpack_public_path__ + "static/media/comment-text.7e386be520e819dd94adddfd05a769fe.svg";
export { ForwardRef as ReactComponent };